module.exports = {
	"en": {
		"conversation": {
			"widget": {
				"title": "Chat with us",
				"subtitle": "Select your market"
			}
		}
	}
};